export default "__VITE_ASSET__CPezoqFW__"